import { Button, Checkbox, Col, DatePicker, Input, Row } from "antd";
import moment from "moment";
import React from "react";
import { useState } from "react";
import { Span } from "./style";

export default ({
  id,
  group,
  dateone = null,
  rep = "",
  handleRep,
  count = "",
}) => {
  const [date, setDate] = useState(dateone);
  const [repetition, setRepetition] = useState(rep);
  const [newCount, setNewCount] = useState(count);

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        flexDirection: "column",
        padding: "15px",
        fontWeight: 600,
      }}
    >
      <Row justify="center" align="middle">
        <Col span={12}>
          <Span>Sana:</Span>
        </Col>
        <Col span={12}>
          <DatePicker
            placeholder=""
            value={date != null ? moment(date) : null}
            onChange={(e) => setDate(moment(e).format("YYYY-MM-DD"))}
            allowClear={false}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Span>Takroriyligi:</Span>
        </Col>
        <Col span={12}>
          <Input
            type="number"
            value={repetition}
            onChange={(e) => setRepetition(e.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Span>Rejasi:</Span>
        </Col>
        <Col span={12}>
          <Input
            type="number"
            value={newCount}
            onChange={(e) => setNewCount(e.target.value)}
          />
        </Col>
      </Row>
      <Row justify="center">
        <Col span={6}>
          <Button
            onClick={() => handleRep(id, group, date, repetition, newCount)}
            type="primary"
          >
            ok
          </Button>
        </Col>
      </Row>
    </div>
  );
};
